import { Box, useMediaQuery } from '@mui/material';
import Lottie from 'lottie-react';
import SelectPropertLottie from '../../assets/lottie/select-property.json';
import { getColor } from '@assets/theme';

/**
 * SelectProperty Component
 *
 * This component renders a Lottie animation for selecting a property.
 * It uses Material-UI's useMediaQuery hook to adjust the animation size for smaller screens.
 *
 * @returns {JSX.Element} A Box component containing the Lottie animation
 */
const SelectProperty = () => {
  // Check if the screen width is 425px or less
  const smallScreen = useMediaQuery('(max-width: 425px)');
  const { white } = getColor();

  return (
    <Box
      sx={{
        position: 'relative',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: white,
      }}
    >
      <Lottie
        animationData={SelectPropertLottie}
        loop={false}
        style={{ width: smallScreen ? '300px' : '650px', height: 'auto' }}
      />
    </Box>
  );
};

export default SelectProperty;
